import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { useClipboardCopy } from '@repo/ui';

import { getConfig } from '@shared/env';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export function useParkingShare(slug: string, testId: TestId) {
  const { copyToClipboard } = useClipboardCopy(testId);

  const share = () => {
    const url = `${getConfig('appUrl')}${ROUTE_PATHS[RouteName.PARKING_LANDING].replace(':slug', slug)}`;
    const text = tr('owned_parking_manage:dashboard.actions.share.message', { url });
    copyToClipboard(text, {
      successMessage: tr('owned_parking_manage:dashboard.actions.share.toast'),
      testIdSuffix: 'shareToast',
    });
  };

  return { shareParking: share };
}
